import type { FC } from 'react';

interface Props {
  className?: string;
}

const WasherDryerIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="3" width="8" height="18" rx="2" strokeWidth="2" />
      <rect x="13" y="3" width="8" height="18" rx="2" strokeWidth="2" />
      <circle cx="7" cy="12" r="3" strokeWidth="2" />
      <circle cx="17" cy="12" r="3" strokeWidth="2" />
      <circle cx="6" cy="6" r="1" fill="currentColor" />
      <circle cx="8" cy="6" r="1" fill="currentColor" />
      <circle cx="16" cy="6" r="1" fill="currentColor" />
      <circle cx="18" cy="6" r="1" fill="currentColor" />
    </svg>
  );
};

export default WasherDryerIcon;
